/**
 * Where a visitor who came in with `?signup=…` lands after Auth0: the page they asked for, without the `signup` hint
 * (it would fire again). The golf landing pages send golfers to `/upload?signup=1` (owner, 2026-10-22: "one is to
 * login + upload"), so they finish signing up on the upload screen, not the dashboard.
 */
export function signupReturnTo(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete("signup");
  const rest = params.toString();
  return (pathname || "/") + (rest ? "?" + rest : "");
}
